<template>
  <div
    class="d-flex align-items-center justify-content-center flex-column px-2 py-6"
    data-cy="anonymous-tab-content"
    data-test="anonymous-tab-content"
  >
    <img width="160"
         src="/img/miscellaneous/security/two-factor-auth-warning.svg"
         alt=""
         loading="lazy"
    />
    <h2 data-test="anonymous-tab-header" class="mt-4">{{ $t('survey.preview.anonymous_survey_title') }}</h2>
    <p data-test="anonymous-tab-description" class="text-muted text-center">{{ $t('survey.preview.anonymous_survey_description') }}</p>
    <b-button variant="link"
              data-cy="change-tab-btn"
              @click="changeTab"
    >{{ $t('survey.preview.to_overview') }}</b-button>
  </div>
</template>

<script>
export default {
  name: 'AnonymousSurveyTabContent',

  emits: ['changeActiveTab'],

  methods: {
    changeTab() {
      this.$emit('changeActiveTab')
    },
  },
}
</script>
